import { defineStore } from 'pinia'
import beApiClient from "@/src/be-api-client";
import {APIRoute, EP } from "@/src/endpoints";
import { handleErrors, makeRequest } from "@/src/utils";

export const useRobocallReductionsStore = defineStore('robocall-reductions', {
  state: ()=> {
    return {
      // lookup data
      active: [],
      transplantCenters: [],
      organGroups: [],
    }
  },
  actions: {
    // Generic load data method
    loadEntity(url, key, params = {}) {
      return new Promise((resolve, reject) => {
        beApiClient.get(url, params).then(response => {
          this[key] = response.data;
          resolve();
        }).catch(error => {
          const message = handleErrors(error);
          reject(message);
        });
      });
    }, 
    // Load unet_emails
    loadUnetEmails(params) {
      return makeRequest(beApiClient.get, APIRoute(EP.admin.unet_emails.index), { params: params });
    },
    loadIncomingSMSLogs(params){
      return makeRequest(beApiClient.get, APIRoute(EP.admin.incoming_sms_logs.index), { params: params });
    },
    loadIncomingCallLogs(params){
      return makeRequest(beApiClient.get, APIRoute(EP.admin.incoming_call_logs.index), { params: params });
    }, 
    // load transplant centres
    loadTransplantCentres() {
      return this.loadEntity(APIRoute(EP.admin.transplant_centers.index), 'transplantCenters')
    },
    // load organ groups
    loadOrganGroups() {
      return this.loadEntity(APIRoute(EP.admin.organ_groups.index), 'organGroups')
    }, 
    // Load robocall reduction
    loadRobocallReduction() {
      return makeRequest(beApiClient.get, APIRoute(EP.admin.application_configurations.robocall_reduction.show));
    },
    enableRobocallReduction() {
      return makeRequest(beApiClient.put, APIRoute(EP.admin.application_configurations.robocall_reduction.enable));
    },
    disableRobocallReduction() {
      return makeRequest(beApiClient.put, APIRoute(EP.admin.application_configurations.robocall_reduction.disable));
    },
    updateRobocallReduction(payload) {
      return makeRequest(beApiClient.patch, APIRoute(EP.admin.application_configurations.robocall_reduction.update), { robocall_reduction: payload });
    },
    updateRobocallAlertSettings(payload) {
      return makeRequest(beApiClient.put, APIRoute(EP.admin.application_configurations.robocall_alerts.update_alert_settings), { robocall_alert: payload });
    },
    updateRobocallAlertEmails(payload) {
      return makeRequest(beApiClient.put, APIRoute(EP.admin.application_configurations.robocall_alerts.update_email), { robocall_alert: payload });
    },
    loadRobocallAlertData() {
      return makeRequest(beApiClient.get, APIRoute(EP.admin.application_configurations.robocall_alerts.show));
    },
    changeAlertEmailStatus(payload) {
      return makeRequest(beApiClient.put, APIRoute(EP.admin.application_configurations.robocall_alerts.toggle_status), { robocall_alert: payload});
    },
    removeAlertEmail(payload) {
      return makeRequest(beApiClient.put, APIRoute(EP.admin.application_configurations.robocall_alerts.remove_email), { robocall_alert: payload });
    }

  }
});